"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectable = void 0;
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
const useSelectable = function (defaultValue, value, onChange) {
  let isMultiple = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const [stateValue, setStateValue] = (0, _reactUseControlledState.default)(defaultValue, value, onChange);
  const getNextValue = optionValue => {
    if (!stateValue) {
      return [];
    }
    if (isMultiple) {
      if (stateValue.includes(optionValue)) {
        return stateValue.filter(v => v !== optionValue);
      }
      return [...stateValue, optionValue];
    }
    return [optionValue];
  };
  const handleOptionChange = optionValue => {
    setStateValue(getNextValue(optionValue));
  };
  const isOptionChecked = optionValue => {
    if (!stateValue) {
      return false;
    }
    return stateValue.includes(optionValue);
  };
  return {
    isOptionChecked,
    onOptionChange: handleOptionChange
  };
};
exports.useSelectable = useSelectable;
//# sourceMappingURL=useSelectable.js.map